<template>
  <div id="app">
    <Navbar />
    <TargetModal :target="getTarget" />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar/Navbar";
import Footer from "@/components/Footer";
import TargetModal from "@/components/TargetModal";
import { mapGetters } from "vuex";

export default {
  components: { Navbar, Footer, TargetModal },
  computed: {
    ...mapGetters(["getTarget"])
  },
  mounted() {
    if (!localStorage.acceptedCookies) {
      this.$buefy.snackbar.open({
        message:
          "We use cookies to enable key features like login and payment. By continuing to use the website, you agree with our <a href='/privacy-policy'>Privacy Policy</a> and <a href='/terms'>Terms of Service</a>",
        position: "is-top",
        actionText: "Got it",
        indefinite: true,
        onAction: () => {
          localStorage.acceptedCookies = true;
        }
      });
    }

    window.onerror = (message, source, lineno, colno, error) => {
      if (!window.umami) return;
      window.umami(`${source} ${lineno},${colno}:${message}`);
      window.umami(`$ErrObj:${JSON.stringify(error)}`);
    };
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  .playlist {
    margin: 0;
  }

  .playlist-time-scale .time {
    font-size: xx-small;
    bottom: 10px;
  }
}
</style>
